<div class="vm-container" *ngIf="enableBackLink !== false">
  <vm-page-heading
    [routerLinkText]="routerLinkText"
    (back)="onBack($event)"></vm-page-heading>
</div>

<div class="vm-container cozy">
  <div class="vm-row">
    <div class="vm-col-xs-12">
      <div class="contact-us">
        <vm-confirmation
          [icon]="confirmationInput?.icon"
          [iconColor]="confirmationInput?.iconColor"
          [iconWeight]="confirmationInput?.iconWeight"
          [title]="confirmationInput?.title"
          [info]="confirmationInput?.info"
          [nextActions]="confirmationInput?.actions"
          [extraInfo]="confirmationInput?.extraInfo"
          [secondaryModalLabel]="confirmationInput?.secondaryModalLabel"
          [secondaryModalCopy]="confirmationInput?.secondaryModalCopy"
          [tertiaryModalLabel]="confirmationInput?.tertiaryModalLabel"
          [tertiaryModalTitle]="confirmationInput?.tertiaryModalTitle"
          [tertiaryModalCopy]="confirmationInput?.tertiaryModalCopy"
          [chatbotId]="confirmationInput?.chatbotId"
          [tiles]="confirmationInput?.tiles"
          (next)="onNext($event)"
          (secondaryModalOpened)="onOpenSecondaryModal()"></vm-confirmation>
      </div>
    </div>
  </div>
</div>
